/**
 * Records API Operations Composable
 * Single Responsibility: Handles all API operations related to records
 */
import { httpService } from '../../services/HttpService';
import { apiConfig } from '../../services/ApiConfig';

export function useRecordsApi() {
  /**
   * Load records data from API
   * @param {Object} params - Request parameters
   * @param {string} params.groupId - Group ID
   * @param {string} params.memberLineId - Member Line ID
   * @returns {Promise<Object>} API response data
   */
  const loadRecordsData = async ({ groupId, memberLineId }) => {
    try {
      const url = apiConfig.getEndpoint('records', 'list', groupId || memberLineId, memberLineId);
      const data = await httpService.get(url);
      return data;
    } catch (error) {
      console.error('Failed to load records data:', error);
      throw new Error(`載入記錄資料失敗: ${error.message}`);
    }
  };

  return {
    loadRecordsData
  };
}